export default from './component';



// WEBPACK FOOTER //
// ./src/components/Page404/index.js